
export const catalogViews = [
    { label: "Default View", value: "default" },
    { label: "Merchandising", value: "merchandising" },
    { label: "Channel", value: "channel" },
    { label: "Operations", value: "operations" },
    { label: "Physical Specs", value: "physical_specs" },
    { label: "Launch Planning", value: "launch_planning" },
    { label: "BOM & Cost", value: "bom_cost" },
    { label: "Data Validation", value: "data_validation" },
    { label: "Supplies", value: "supplies" },
    { label: "Packaging Products", value: "packaging_products" },
    { label: "Deleted Products", value: "deleted_products" },
    { label: "SKU Mapping Products", value: "sku_mapping_products" },
    { label: "New Products", value: "new_products" },
];

export const PRODUCT_CATALOG_EXPORT_EXCLUDED_COLUMN_IDS = ["image"];

export const COLUMN_GROUP_ORDER = [
    "identity",
    "classification",
    "commercial",
    "channel",
    "operations",
    "finance",
    "physical",
    "lifecycle",
    "attributes",
];
  
export const GROUP_LABELS = {
    identity: "Identity",
    classification: "Classification",
    commercial: "Commercial",
    channel: "Channel",
    operations: "Operations",
    finance: "Finance",
    physical: "Physical Attributes",
    lifecycle: "Lifecycle",
    attributes: "Attributes",
};
  
export const DEFAULT_COLUMNS = [
    // Identity (pinned left — Variant is NOT pinned)
    {
      id: "image",
      label: "",
      group: "identity",
      width: 40,
      visible: true,
      pinned: "left",
      sortable: false,
      readonly: false,
    },
    {
      id: "supply_sku",
      label: "Supply SKU",
      group: "identity",
      width: 180,
      visible: true,
      pinned: "left",
      sortable: true,
      readonly: true,
    },
    {
      id: "canonical_product_name",
      label: "Canonical Name",
      group: "identity",
      width: 280,
      visible: true,
      pinned: "left",
      sortable: true,
      readonly: true,
    },
    {
      id: "product_name",
      label: "Product Name",
      group: "identity",
      width: 220,
      visible: true,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    // Classification
    {
      id: "variant_name",
      label: "Variant",
      group: "identity",
      width: 250,
      visible: true,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    {
      id: "fba_asin",
      label: "FBA ASIN",
      group: "identity",
      width: 170,
      visible: true,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    {
      id: "fbm_asin",
      label: "FBM ASIN",
      group: "identity",
      width: 170,
      visible: true,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    {
      id: "category",
      label: "Category",
      group: "classification",
      width: 135,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "subcategory",
      label: "Subcategory",
      group: "classification",
      width: 160,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "status",
      label: "Status",
      group: "classification",
      width: 120,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "entry_engine",
      label: "Entry Engine",
      group: "classification",
      width: 140,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "brand_pillar",
      label: "Brand Pillar",
      group: "classification",
      width: 145,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "demand_tier",
      label: "Demand Tier",
      group: "classification",
      width: 130,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "is_protected",
      label: "Protected",
      group: "classification",
      width: 150,
      visible: true,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    {
      id: "max_discount_pct",
      label: "Max Discount %",
      group: "classification",
      width: 185,
      visible: true,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    {
      id: "max_discount_price",
      label: "Max Discount Price",
      group: "classification",
      width: 215,
      visible: true,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    {
      id: "intent",
      label: "Intent",
      group: "classification",
      width: 140,
      visible: true,
      pinned: null,
      sortable: true,
    },
    // Commercial
    {
      id: "msrp",
      label: "MSRP",
      group: "commercial",
      width: 90,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "shopify_planned_gross_price",
      label: "Shopify Planned Gross Price",
      group: "commercial",
      width: 170,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "amazon_planned_gross_price",
      label: "Amazon Planned Gross Price",
      group: "commercial",
      width: 170,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "moq",
      label: "MOQ",
      group: "commercial",
      width: 90,
      visible: true,
      pinned: null,
      sortable: true,
    },
    // Channel
    {
      id: "sell_on_shopify",
      label: "Shopify",
      group: "channel",
      width: 100,
      visible: true,
      pinned: null,
      sortable: false,
      readonly: true,
    },
    {
      id: "sell_on_amazon",
      label: "Amazon",
      group: "channel",
      width: 100,
      visible: true,
      pinned: null,
      sortable: false,
      readonly: true,
    },
    {
      id: "amazon_fbm_sku",
      label: "FBM SKU",
      group: "channel",
      width: 140,
      visible: false,
      pinned: null,
      sortable: false,
      readonly: true,
    },
    {
      id: "amazon_fba_sku",
      label: "FBA SKU",
      group: "channel",
      width: 140,
      visible: false,
      pinned: null,
      sortable: false,
      readonly: true,
    },
    {
      id: "shopify_product_id",
      label: "Shopify ID",
      group: "channel",
      width: 130,
      visible: false,
      pinned: null,
      sortable: false,
      readonly: true,
    },
    // Operations
    {
      id: "supplier",
      label: "Supplier",
      group: "operations",
      width: 200,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "lead_time_days",
      label: "MFG Lead Time",
      group: "operations",
      width: 130,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "transit_lead_time_days",
      label: "Transit Time",
      group: "operations",
      width: 120,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "total_lead_time_days",
      label: "Total Lead Time",
      group: "operations",
      width: 140,
      visible: true,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    {
      id: "container_group_id",
      label: "Container Group",
      group: "operations",
      width: 145,
      visible: false,
      pinned: null,
      sortable: true,
    },
    {
      id: "container_qty",
      label: "Container QTY",
      group: "operations",
      width: 140,
      visible: false,
      pinned: null,
      sortable: true,
    },
    {
      id: "carton_qty",
      label: "Carton QTY",
      group: "operations",
      width: 120,
      visible: false,
      pinned: null,
      sortable: true,
    },
    {
      id: "packaging_sku",
      label: "Packaging SKU",
      group: "operations",
      width: 170,
      visible: false,
      pinned: null,
      sortable: false,
      readonly: true,
    },
    // Finance
    {
      id: "product_bom_cost",
      label: "Product BOM Cost",
      group: "finance",
      width: 180,
      visible: false,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    {
      id: "packaging_bom_cost",
      label: "Packaging BOM Cost",
      group: "finance",
      width: 190,
      visible: false,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    // Physical
    {
      id: "unit_weight_lbs",
      label: "Weight (lbs)",
      group: "physical",
      width: 125,
      visible: false,
      pinned: null,
      sortable: true,
    },
    {
      id: "unit_length",
      label: "Length (in)",
      group: "physical",
      width: 100,
      visible: false,
      pinned: null,
      sortable: false,
    },
    {
      id: "unit_width",
      label: "Width (in)",
      group: "physical",
      width: 100,
      visible: false,
      pinned: null,
      sortable: false,
    },
    {
      id: "unit_height",
      label: "Height (in)",
      group: "physical",
      width: 100,
      visible: false,
      pinned: null,
      sortable: false,
    },
    {
      id: "cubic_inches",
      label: "Cubic Inches",
      group: "physical",
      width: 150,
      visible: false,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    // Lifecycle
    {
      id: "launch_date",
      label: "Launch Date",
      group: "lifecycle",
      width: 155,
      visible: true,
      pinned: null,
      sortable: true,
    },
    {
      id: "sunset_date",
      label: "Sunset Date",
      group: "lifecycle",
      width: 155,
      visible: false,
      pinned: null,
      sortable: true,
    },
    {
      id: "inactive_date",
      label: "Inactive Date",
      group: "lifecycle",
      width: 155,
      visible: false,
      pinned: null,
      sortable: true,
    },
    {
      id: "created_date",
      label: "Created",
      group: "lifecycle",
      width: 130,
      visible: false,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    {
      id: "last_modified",
      label: "Last Modified",
      group: "lifecycle",
      width: 170,
      visible: false,
      pinned: null,
      sortable: true,
      readonly: true,
    },
    // Attributes
    {
      id: "color",
      label: "Color",
      group: "attributes",
      width: 120,
      visible: false,
      pinned: null,
      sortable: true,
    },
    {
      id: "material",
      label: "Material",
      group: "attributes",
      width: 300,
      visible: false,
      pinned: null,
      sortable: false,
    },
    {
      id: "barcode",
      label: "Barcode",
      group: "attributes",
      width: 150,
      visible: false,
      pinned: null,
      sortable: false,
      readonly: true,
    },
];

export const productCatalogStatuses = [
    { label: "Active", value: "ACTIVE" },
    { label: "Planned", value: "PLANNED" },
    { label: "Sunset", value: "SUNSET" },
    { label: "Inactive", value: "IN_ACTIVE" },
];

export const productCatalogProducts = [
    { label: "Needs Review", value: "NEEDS_REVIEW" },
    { label: "Missing BOM", value: "MISSING_BOM" },
    { label: "Missing MSRP", value: "MISSING_MSRP" },
    { label: "Missing Category", value: "MISSING_CATEGORY" },
    { label: "Missing Dimensions", value: "MISSING_DIMENSIONS" },
    { label: "Missing Launch Date", value: "MISSING_LAUNCH_DATE" },
    { label: "Not Forecastable", value: "NOT_FORECASTABLE" },
    { label: "Missing Sales Channel", value: "MISSING_SALES_CHANNEL" },
];
  
export const cloneColumns = (cols) => cols.map((c) => ({ ...c }));

/** Legacy catalog column ids migrated to FK-backed ids (e.g. free-text container_group → container_group_id). */
export const CATALOG_COLUMN_ID_ALIASES = {
  container_group: "container_group_id",
};

export function normalizeCatalogColumnId(columnId) {
  return CATALOG_COLUMN_ID_ALIASES[columnId] || columnId;
}

/** Dedupes renamed columns; prefers a visible entry when both legacy and new ids exist. */
export function normalizeCatalogColumns(columns = []) {
  const byId = new Map();
  (columns || []).forEach((column) => {
    if (!column?.id) return;
    const id = normalizeCatalogColumnId(column.id);
    const prev = byId.get(id);
    if (!prev || column.visible === true) {
      byId.set(id, { ...column, id });
    }
  });
  return [...byId.values()];
}

export function normalizeCatalogColumnsByView(byView = {}) {
  if (!byView || typeof byView !== "object" || Array.isArray(byView)) return {};
  const out = {};
  Object.entries(byView).forEach(([viewKey, columns]) => {
    if (Array.isArray(columns)) {
      out[viewKey] = normalizeCatalogColumns(columns);
    }
  });
  return out;
}

export function normalizeProductCatalogCustomViews(customViews = []) {
  if (!Array.isArray(customViews)) return [];
  const seen = new Set();
  return customViews.reduce((out, view) => {
    if (!view || typeof view !== "object") return out;
    const id = String(view.id || "").trim();
    const name = String(view.name || "").trim();
    const baseView = String(view.base_view || view.baseView || "").trim();
    if (!id || !name || !baseView || seen.has(id) || catalogViews.some((preset) => preset.value === id)) {
      return out;
    }
    seen.add(id);
    out.push({ id, name, base_view: catalogViews.some((preset) => preset.value === baseView) ? baseView : "default" });
    return out;
  }, []);
}
